import { __awaiter, __generator, __assign } from '../node_modules/tslib/tslib.es6.js';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import { Logger, Auth, Hub } from 'aws-amplify';
import { tryGetVisitorId } from '../analytics/fingerprint.js';
import '../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../types/filters.js';
import '../utils/assetUtils.js';
import BrandclubStoreConfigUtils from '../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import 'he';
import '../utils/broadcast.js';
import '../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'react';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '../types/Campaign.js';
import '../types/product.js';
import '../api/graphQl/brand.js';
import '../api/graphQl/product.js';
import '@brandclub/types';
import { Logger as Logger$1 } from '../utils/logger.js';
import CrossDomainStorage from './CrossDomainStorage.js';
export { default as CrossDomainStorage } from './CrossDomainStorage.js';

var AmplifyAuth = Auth;
var AmplifyHub = Hub;
Logger.LOG_LEVEL = "NONE";
var logger = new Logger$1('Auth', BrandclubStoreConfigUtils.getAppStage());
var sharedVisitorIdCookieName = BrandclubStoreConfigUtils.getAppStage() === "prod"
    ? "bcVisitorId"
    : "bcVisitorId-".concat(BrandclubStoreConfigUtils.getAppStage());
var authConfiguredPromise = new Promise(function (resolve) {
    var unsubscribe = AmplifyHub.listen("auth", function (data) {
        var _a;
        if (((_a = data === null || data === void 0 ? void 0 : data.payload) === null || _a === void 0 ? void 0 : _a.event) === "configured") {
            unsubscribe();
            resolve();
        }
    });
});
var waitForAuthConfigured = function (timeout) {
    if (timeout === void 0) { timeout = 5000; }
    return __awaiter(void 0, void 0, void 0, function () {
        var timeoutPromise;
        return __generator(this, function (_a) {
            timeoutPromise = new Promise(function (_, reject) {
                logger.debug("Waiting for auth to be configured with timeout of ".concat(timeout, "ms"));
                setTimeout(function () {
                    reject(new Error("Auth not configured after timeout"));
                }, timeout);
            });
            return [2 /*return*/, Promise.race([authConfiguredPromise, timeoutPromise])];
        });
    });
};
var getAWSCognitoConfig = function (authConfig, domainName) { return __awaiter(void 0, void 0, void 0, function () {
    var appStage, authDomain, authOrigin, storage, cognitoCredentials_1, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                appStage = BrandclubStoreConfigUtils.getAppStage();
                authDomain = BrandclubStoreConfigUtils.getLocalStorageDomain(appStage, {
                    domainName: domainName,
                });
                authOrigin = "https://".concat(authDomain);
                if (domainName) {
                    logger.debug("Using auth origin from provided domainName: ".concat(domainName));
                }
                else {
                    logger.warn("Using fallback localStorageDomain: ".concat(authOrigin, " as domainName is not provided"));
                }
                storage = CrossDomainStorage.createInstance(authOrigin, appStage);
                return [4 /*yield*/, storage.initialize()];
            case 1:
                _a.sent();
                cognitoCredentials_1 = undefined;
                return [2 /*return*/, {
                        region: authConfig.region,
                        userPoolId: authConfig.userPoolId,
                        userPoolWebClientId: authConfig.userPoolClientId,
                        oauth: {
                            domain: authConfig.signInDomain,
                            scope: [
                                "phone",
                                "email",
                                "profile",
                                "openid",
                                "aws.cognito.signin.user.admin",
                            ],
                            redirectSignIn: "".concat(origin, "/signinredirect"),
                            redirectSignOut: "".concat(origin, "/signoutredirect"),
                            responseType: "code",
                        },
                        storage: storage,
                        Auth: {
                            domain: authDomain,
                            userPoolId: authConfig.userPoolId,
                            clientId: authConfig.userPoolClientId,
                            identityPoolId: authConfig.identityPoolId,
                            userPoolWebClientId: authConfig.userPoolClientId,
                            ClientId: authConfig.userPoolClientId,
                            region: authConfig.region,
                            credentials: (function () {
                                if (!authConfig.identityPoolId) {
                                    return undefined;
                                }
                                if (!cognitoCredentials_1) {
                                    cognitoCredentials_1 = fromCognitoIdentityPool({
                                        identityPoolId: authConfig.identityPoolId,
                                        clientConfig: { region: authConfig.region },
                                    });
                                }
                                return cognitoCredentials_1;
                            })(),
                        },
                    }];
            case 2:
                err_1 = _a.sent();
                logger.error("Error getting AWS Cognito config", err_1);
                throw err_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
// Add function to redeem login code
var redeemBrandAppLoginCode = function (_a) {
    var apiDomain = _a.apiDomain, loginCode = _a.loginCode, signal = _a.signal;
    return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!apiDomain) {
                        apiDomain = BrandclubStoreConfigUtils.getApiHostName();
                    }
                    else {
                        apiDomain = "https://" + apiDomain;
                    }
                    return [4 /*yield*/, fetch("".concat(apiDomain, "/api-rewards/brandapp/redeemBrandAppLoginCode"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({ loginCode: loginCode }),
                            signal: signal,
                        })];
                case 1:
                    res = _b.sent();
                    if (res.ok) {
                        return [2 /*return*/, res.json()];
                    }
                    else {
                        throw new Error("Error redeeming brand app login code");
                    }
            }
        });
    });
};
// Add function to check and handle login code
var checkAndHandleLoginCode = function (apiDomain) { return __awaiter(void 0, void 0, void 0, function () {
    var url, loginCode, shouldLogOut, res, tokenParts, payload, username, appStage, storage, tempAuthData, error_1, error_2;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                url = new URL(window.location.href);
                loginCode = url.searchParams.get("bcLoginCode");
                shouldLogOut = url.searchParams.get("bcLogout") === "1";
                if (!loginCode && !shouldLogOut) {
                    return [2 /*return*/, false];
                }
                // delete from the url without reloading the page
                url.searchParams.delete("bcLoginCode");
                url.searchParams.delete("bcLogout");
                window.history.replaceState({}, document.title, url.toString());
                _c.label = 1;
            case 1:
                _c.trys.push([1, 9, , 10]);
                if (!(loginCode && !shouldLogOut)) return [3 /*break*/, 3];
                logger.debug("Found login code in URL, attempting to redeem ".concat(loginCode, " from ").concat(apiDomain));
                return [4 /*yield*/, redeemBrandAppLoginCode({ apiDomain: apiDomain, loginCode: loginCode })];
            case 2:
                res = _c.sent();
                if (res.status === "success" &&
                    ((_a = res.data) === null || _a === void 0 ? void 0 : _a.accessToken) &&
                    ((_b = res.data) === null || _b === void 0 ? void 0 : _b.refreshToken)) {
                    logger.debug("Login code redeemed successfully");
                    tokenParts = res.data.accessToken.split('.');
                    if (tokenParts.length === 3) {
                        try {
                            payload = JSON.parse(atob(tokenParts[1]));
                            username = payload.username || payload['cognito:username'] || payload.sub;
                            appStage = BrandclubStoreConfigUtils.getAppStage();
                            storage = CrossDomainStorage.getCurrentInstance();
                            if (!storage) {
                                logger.error("CrossDomainStorage not initialized when trying to store login tokens");
                                return [2 /*return*/, false];
                            }
                            if (username) {
                                tempAuthData = {
                                    accessToken: res.data.accessToken,
                                    accessTokenExpiresIn: res.data.accessTokenExpiresIn,
                                    refreshToken: res.data.refreshToken,
                                    refreshTokenExpiresIn: res.data.refreshTokenExpiresIn,
                                    username: username,
                                    timestamp: Date.now()
                                };
                                // Store in a temporary key that we'll process after Auth is initialized
                                storage.setItem("bc-pending-auth-".concat(appStage), JSON.stringify(tempAuthData));
                                return [2 /*return*/, true];
                            }
                        }
                        catch (error) {
                            logger.error("Error parsing access token:", error);
                        }
                    }
                }
                return [3 /*break*/, 8];
            case 3:
                if (!shouldLogOut) return [3 /*break*/, 8];
                _c.label = 4;
            case 4:
                _c.trys.push([4, 6, 7, 8]);
                logger.debug("Found bcLogout in URL, attempting to log out");
                return [4 /*yield*/, signOut()];
            case 5:
                _c.sent();
                return [2 /*return*/, true];
            case 6:
                error_1 = _c.sent();
                logger.error("Error signing out:", error_1);
                return [2 /*return*/, true];
            case 7:
                url.searchParams.delete("bcLogout");
                window.history.replaceState({}, document.title, url.toString());
                return [7 /*endfinally*/];
            case 8: return [3 /*break*/, 10];
            case 9:
                error_2 = _c.sent();
                logger.error("Error redeeming login code:", error_2);
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/, false];
        }
    });
}); };
var initializeAuth = function (authConfig, domainName) { return __awaiter(void 0, void 0, void 0, function () {
    var cognitoConfig, hasLoginCode, appStage, storage, pendingAuthKey, pendingAuthData, authData, clientId, username, keyPrefix, clockDrift, tokenParts, payload, userData, key;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getAWSCognitoConfig(authConfig, domainName)];
            case 1:
                cognitoConfig = _a.sent();
                Auth.configure(cognitoConfig);
                return [4 /*yield*/, checkAndHandleLoginCode(domainName)];
            case 2:
                hasLoginCode = _a.sent();
                appStage = BrandclubStoreConfigUtils.getAppStage();
                storage = CrossDomainStorage.getCurrentInstance();
                if (storage) {
                    pendingAuthKey = "bc-pending-auth-".concat(appStage);
                    pendingAuthData = storage.getItem(pendingAuthKey);
                    if (pendingAuthData) {
                        try {
                            authData = JSON.parse(pendingAuthData);
                            clientId = authConfig.userPoolClientId;
                            username = authData.username;
                            keyPrefix = "CognitoIdentityServiceProvider.".concat(clientId, ".").concat(username);
                            // Store access token
                            storage.setItem("".concat(keyPrefix, ".accessToken"), authData.accessToken);
                            // Store refresh token
                            storage.setItem("".concat(keyPrefix, ".refreshToken"), authData.refreshToken);
                            // Store ID token (we'll use the access token as ID token for now since we don't have it)
                            // TODO: The redeemBrandAppLoginCode API should be updated to return the ID token as well
                            // The ID token contains user profile information and is required by Amplify Auth
                            storage.setItem("".concat(keyPrefix, ".idToken"), authData.accessToken);
                            // Store the last authenticated user
                            storage.setItem("CognitoIdentityServiceProvider.".concat(clientId, ".LastAuthUser"), username);
                            clockDrift = 0;
                            storage.setItem("".concat(keyPrefix, ".clockDrift"), clockDrift.toString());
                            tokenParts = authData.accessToken.split('.');
                            if (tokenParts.length === 3) {
                                payload = JSON.parse(atob(tokenParts[1]));
                                userData = {
                                    UserAttributes: [
                                        { Name: 'sub', Value: payload.sub || username },
                                    ],
                                    Username: username
                                };
                                for (key in payload) {
                                    if (key !== "sub" && key !== "cognito:username") {
                                        userData.UserAttributes.push({ Name: key, Value: payload[key] });
                                    }
                                }
                                storage.setItem("".concat(keyPrefix, ".userData"), JSON.stringify(userData));
                            }
                            // Remove the pending auth data
                            storage.removeItem(pendingAuthKey);
                            logger.debug("Successfully processed pending auth tokens");
                            // Dispatch auth event to notify the app that user is signed in
                            Hub.dispatch("auth", {
                                event: "signIn",
                                data: { username: username },
                            });
                            // If we processed pending auth, reload to ensure Auth picks up the tokens
                            if (hasLoginCode) {
                                window.location.reload();
                            }
                        }
                        catch (error) {
                            logger.error("Error processing pending auth tokens:", error);
                            storage.removeItem(pendingAuthKey);
                        }
                    }
                }
                return [2 /*return*/, cognitoConfig];
        }
    });
}); };
var amplifyAuthPromise = null;
var initializeAmplifyAuth = function (authConfig, domainName) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (!amplifyAuthPromise) {
            amplifyAuthPromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
                var err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, initializeAuth(authConfig, domainName)];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            err_2 = _a.sent();
                            logger.error("Error initializing Amplify Auth", err_2);
                            // reset the promise to allow for a new attempt
                            amplifyAuthPromise = null;
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
        }
        return [2 /*return*/, amplifyAuthPromise];
    });
}); };
var getAccessToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var session, accessToken;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Auth.currentSession().catch(function (_e) {
                    return null;
                })];
            case 1:
                session = _a.sent();
                if (!session) {
                    return [2 /*return*/, null];
                }
                accessToken = session.getAccessToken();
                return [2 /*return*/, accessToken];
        }
    });
}); };
var getRefreshToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var session;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Auth.currentSession().catch(function (_e) {
                    return null;
                })];
            case 1:
                session = _a.sent();
                if (!session) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, session === null || session === void 0 ? void 0 : session.getRefreshToken()];
        }
    });
}); };
// Promise cache for deduplicating concurrent calls
var pendingUserSignedInStatePromise = null;
var createAuthResponse = function (userInfo) {
    if (!userInfo || !userInfo.username) {
        return { signedIn: false, userInfo: null };
    }
    return { signedIn: true, userInfo: userInfo };
};
var getUserSignedInState = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        // Return existing promise if one is pending
        if (pendingUserSignedInStatePromise) {
            return [2 /*return*/, pendingUserSignedInStatePromise];
        }
        // Create new promise and cache it
        pendingUserSignedInStatePromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
            var session, userInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, Auth.currentSession()];
                    case 1:
                        session = _a.sent();
                        if (!session || !session.isValid()) {
                            return [2 /*return*/, createAuthResponse(undefined)];
                        }
                        return [4 /*yield*/, Auth.currentUserInfo()];
                    case 2:
                        userInfo = _a.sent();
                        if (!userInfo || !userInfo.username) {
                            return [2 /*return*/, createAuthResponse(undefined)];
                        }
                        return [2 /*return*/, createAuthResponse(userInfo)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, createAuthResponse(undefined)];
                    case 4:
                        pendingUserSignedInStatePromise = null;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); })();
        return [2 /*return*/, pendingUserSignedInStatePromise];
    });
}); };
var signOut = function () { return __awaiter(void 0, void 0, void 0, function () {
    var jwt, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, waitForAuthConfigured()];
            case 1:
                _a.sent();
                return [4 /*yield*/, Auth.signOut()];
            case 2:
                _a.sent();
                return [4 /*yield*/, getJwt()];
            case 3:
                jwt = _a.sent();
                if (jwt) {
                    logger.error("Failed to sign out, JWT still exists");
                }
                else {
                    logger.debug("Signed out successfully dispatching signOut event and clearing query cache");
                    AmplifyHub.dispatch("auth", { event: "signOut" });
                }
                return [3 /*break*/, 5];
            case 4:
                e_2 = _a.sent();
                logger.error("Error signing out", e_2);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
var getJwt = function () { return __awaiter(void 0, void 0, void 0, function () {
    var accessToken, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getAccessToken()];
            case 1:
                accessToken = _a.sent();
                return [2 /*return*/, (accessToken === null || accessToken === void 0 ? void 0 : accessToken.getJwtToken()) || ""];
            case 2:
                e_3 = _a.sent();
                if (e_3 !== "No current user") {
                    logger.error("Error getting JWT", e_3);
                }
                return [2 /*return*/, ""];
            case 3: return [2 /*return*/];
        }
    });
}); };
var getVisitorIdHeader = function () { return __awaiter(void 0, void 0, void 0, function () {
    var uniqueVisitorId, uniqueVisitorIdFromCookie, uniqueVisitorIdToUse, headers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tryGetVisitorId()];
            case 1:
                uniqueVisitorId = _a.sent();
                uniqueVisitorIdFromCookie = getVisitorIdCookie();
                uniqueVisitorIdToUse = uniqueVisitorIdFromCookie && uniqueVisitorIdFromCookie !== ""
                    ? uniqueVisitorIdFromCookie
                    : uniqueVisitorId;
                headers = {};
                if (uniqueVisitorIdToUse) {
                    headers["x-bc-visitor-id"] = uniqueVisitorIdToUse;
                }
                return [2 /*return*/, headers];
        }
    });
}); };
var getAuthorizationHeader = function () { return __awaiter(void 0, void 0, void 0, function () {
    var headers, sessionToken;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                headers = {};
                return [4 /*yield*/, getAccessToken()];
            case 1:
                sessionToken = _a.sent();
                if (sessionToken) {
                    headers["Authorization"] = "Bearer ".concat(sessionToken.getJwtToken());
                }
                return [2 /*return*/, headers];
        }
    });
}); };
var getHeadersWithUniqueVisitorId = function () { return __awaiter(void 0, void 0, void 0, function () {
    var uniqueVisitorId, uniqueVisitorIdFromCookie, uniqueVisitorIdToUse, jwt, headers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tryGetVisitorId()];
            case 1:
                uniqueVisitorId = _a.sent();
                uniqueVisitorIdFromCookie = getVisitorIdCookie();
                uniqueVisitorIdToUse = uniqueVisitorIdFromCookie && uniqueVisitorIdFromCookie !== ""
                    ? uniqueVisitorIdFromCookie
                    : uniqueVisitorId;
                return [4 /*yield*/, getJwt()];
            case 2:
                jwt = _a.sent();
                headers = {
                    "Content-Type": "application/json"
                };
                if (jwt) {
                    headers["Authorization"] = "Bearer ".concat(jwt);
                }
                if (uniqueVisitorIdToUse) {
                    headers["x-bc-visitor-id"] = uniqueVisitorIdToUse;
                }
                return [2 /*return*/, headers];
        }
    });
}); };
var setOtpAuth = function (userInfo) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, dispatchSignInComplete(userInfo)];
    });
}); };
var dispatchSignInComplete = function (userInfo) {
    userInfo = __assign(__assign(__assign({}, userInfo), (userInfo.cognitoUserAttributes || {})), { username: userInfo.username || userInfo.userId });
    Hub.dispatch("auth", {
        event: "signIn_Complete",
        data: { username: userInfo.username },
    });
};
var getVisitorIdCookie = function () {
    var name = "".concat(sharedVisitorIdCookieName, "=");
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

export { AmplifyAuth, AmplifyHub, dispatchSignInComplete, getAccessToken, getAuthorizationHeader, getHeadersWithUniqueVisitorId, getJwt, getRefreshToken, getUserSignedInState, getVisitorIdCookie, getVisitorIdHeader, initializeAmplifyAuth, setOtpAuth, signOut, waitForAuthConfigured };
//# sourceMappingURL=index.js.map
